import { useMemo } from "react";
import { Copy, Users, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function ReferralCard() {
  const { user } = useAuth();
  const shareUrl = useMemo(() => {
    if (!user?.referral_code) return "";
    return `${window.location.origin}/register?ref=${user.referral_code}`;
  }, [user?.referral_code]);

  if (!user?.referral_code) return null;

  const copy = () => { navigator.clipboard.writeText(shareUrl); toast.success("Referral link copied"); };
  const share = () => {
    const text = `I built with The Good Guys — one API for phone/email/IP verification. Grab 100 bonus credits on me: ${shareUrl}`;
    const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
    window.open(twitter, "_blank", "noopener");
  };

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/60 p-6" data-testid="referral-card">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display font-semibold text-lg flex items-center gap-2">
          <Users className="w-5 h-5 text-cyan-signal" /> Refer &amp; earn
        </h3>
        <div className="text-right">
          <div className="text-xl font-display font-bold text-cyan-signal tabular-nums">{user.referrals_count}</div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">signups</div>
        </div>
      </div>
      <p className="text-sm text-slate-400">Every friend who signs up through your link gets <span className="text-cyan-signal font-mono">+100 credits</span>. So do you. Cash the credits in on any validator — no cap.</p>
      <div className="mt-4 flex items-center gap-2 rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2">
        <code data-testid="referral-link" className="flex-1 font-mono text-xs sm:text-sm text-slate-200 truncate">{shareUrl}</code>
        <Button size="sm" variant="ghost" onClick={copy} className="text-slate-400 hover:text-white" data-testid="btn-referral-copy"><Copy className="w-4 h-4" /></Button>
      </div>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={share} className="bg-cyan-signal text-slate-950 hover:bg-cyan-400 font-semibold" data-testid="btn-referral-share">
          <Share2 className="w-4 h-4 mr-1.5" /> Share on X
        </Button>
        {user.referral_credits_earned > 0 && (
          <span className="text-xs font-mono text-emerald-400 self-center">+{user.referral_credits_earned.toLocaleString()} earned</span>
        )}
      </div>
    </div>
  );
}
